/**
 * ConversationSkeleton Organism Component
 * 
 * Loading skeleton for conversation messages.
 * Displays animated placeholders for user and AI messages
 * while conversation history is being loaded.
 */

import React from 'react';

// ============================================================================
// TYPES
// ============================================================================

export interface ConversationSkeletonProps {
  /**
   * Number of message pairs (user + AI) to display
   * @default 3
   */
  messageCount?: number;
}

// ============================================================================
// COMPONENT
// ============================================================================

export const ConversationSkeleton: React.FC<ConversationSkeletonProps> = ({
  messageCount = 3,
}) => {
  return (
    <div className="w-main-width pb-4 animate-pulse">
      {Array.from({ length: messageCount }, (_, index) => (
        <div key={index} className="pb-6">
          {/* User message skeleton */}
          <div className="flex justify-end mb-4">
            <div className="bg-gray-200 rounded-lg p-4 max-w-[80%] w-80">
              <div className="h-4 bg-gray-300 rounded mb-2"></div>
              <div className="h-4 bg-gray-300 rounded w-3/4"></div>
            </div>
          </div>

          {/* AI message skeleton */}
          <div className="flex items-start gap-2">
            {/* AI Icon skeleton */}
            <div className="w-5 h-5 bg-gray-300 rounded-full flex-shrink-0 mt-1"></div>

            {/* AI message content skeleton */}
            <div className="flex-1 max-w-[95%]">
              <div className="space-y-3">
                <div className="h-4 bg-gray-200 rounded w-full"></div>
                <div className="h-4 bg-gray-200 rounded w-11/12"></div>
                <div className="h-4 bg-gray-200 rounded w-4/5"></div>
                <div className="h-4 bg-gray-200 rounded w-full"></div>
                <div className="h-4 bg-gray-200 rounded w-3/4"></div>

                {/* Simulate list items */}
                <div className="ml-6 space-y-2">
                  <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                  <div className="h-3 bg-gray-200 rounded w-4/5"></div>
                  <div className="h-3 bg-gray-200 rounded w-3/4"></div>
                </div>

                <div className="h-4 bg-gray-200 rounded w-full"></div>
                <div className="h-4 bg-gray-200 rounded w-2/3"></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ConversationSkeleton;
